import { FunctionComponent } from 'react';

import { routes } from '~/client/config/routes';
import { getPropertyDisplayName } from '~/client/utils/properties';
import { Property } from '~/common/types/buildings';

import { PageHeader } from '../PageHeader';
import { HeaderDetails } from './HeaderDetails';

interface Props {
  property: Property;
  includeDetails?: boolean;
}

export const PropertyHeader: FunctionComponent<Props> = ({ property, includeDetails }) => {
  const name = getPropertyDisplayName(property);

  return (
    <PageHeader breadcrumbLinks={[{ name: 'Home', link: routes.home }, { name }]}>
      <h1>{name}</h1>
      <address>{property.address}</address>

      {includeDetails && <HeaderDetails property={property} />}
    </PageHeader>
  );
};
